export default __webpack_public_path__ + "static/media/no-image.9b8ac350.gif";